module.exports = __webpack_public_path__ + "static/media/vildanOkan.d0b7afea.png";